// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3N57Y","title":"Images45_title__3kUfI","images":"Images45_images__1aYMQ"};